import PRODUCT_TYPE_INFO from '../definitions/ProductTypeInfo';
import getCreditCardURL, { CC_URL_SLUGS } from '../functions/getCreditCardURL';


/**
 * Maps a PRODUCT_TYPES value to the EN/FR landing page URL for this type of card
 * @param {object} cardInfo
 * @param {string} cardInfo.productType
 * @param {string} [language=en]
 * @return {string} product type’s Ratehub landing page URL
 */
export default function getCardProductTypeLandingPage({ productType }, language) {
    const url = PRODUCT_TYPE_INFO[productType]?.[`slug_${language}`];

    if (!url) {
        throw new RangeError(`getCardProductTypeLandingPage: Can’t get landing page URL for “${productType}” in “${language}”.`);
    }

    return getCreditCardURL(language, CC_URL_SLUGS.BASE, url);
}
